import { ResourceWithPopover } from "./ResourceWithPopover"

import type { RowClick } from "@/hooks/useLinkDrawerTooltip"
import type { TFunction } from "@/hooks/useTranslation"
import type { ResourceCellProps } from "."

export const ResourceCell = (attr: { t: TFunction; onRowClick: RowClick }) =>
  function ResourceCellComponent(
    value: string,
    { key, ...props }: Omit<ResourceCellProps, "t">
  ) {
    return (
      <ResourceWithPopover key={key} valueCell={value} {...props} {...attr} />
    )
  }
